import whatInput from 'what-input';
export const ask = (strategy = 'input') => {
    return whatInput.ask(strategy);
};
